import { ChevronDown } from 'lucide-react';

/**
 * Divisor de seção da Inbox (Brief 2B T1 §6.4).
 *
 * Separa "Em atendimento" e "Em espera" na lista de conversas.
 * Clicável para colapsar/expandir a seção. Usa as classes `.inbox-section`
 * já materializadas em inbox-2b.css (chevron rotaciona via [data-collapsed]).
 */
export function InboxSectionDivider({
  label,
  count,
  collapsed,
  onToggle,
}: {
  label: string;
  count: number;
  collapsed: boolean;
  onToggle: () => void;
}): JSX.Element {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="inbox-section w-full text-left"
      data-collapsed={collapsed}
      aria-expanded={!collapsed}
      aria-label={`${label} — ${count} conversa${count !== 1 ? 's' : ''}. ${collapsed ? 'Expandir' : 'Colapsar'}`}
    >
      <ChevronDown className="inbox-section__chevron" aria-hidden />
      <span className="inbox-section__label">{label}</span>
      <span className="inbox-section__count">({count})</span>
      <span className="inbox-section__rule" aria-hidden />
    </button>
  );
}
